// Every answer is server-rendered and visible without JavaScript. Enhancement collapses
// them into an accordion where one question is open at a time, starting fully closed.
document.querySelectorAll("[data-faq-section]").forEach((root) => {
    const questions = [...root.querySelectorAll("[data-faq-question]")];

    function open(selected) {
        questions.forEach((question) => {
            const expanded = question === selected;
            question.setAttribute("aria-expanded", String(expanded));
            document.getElementById(question.getAttribute("aria-controls")).hidden = !expanded;
        });
    }

    root.addEventListener("click", (event) => {
        const question = event.target.closest("[data-faq-question]");
        if (question) {
            open(question.getAttribute("aria-expanded") === "true" ? null : question);
        }
    });

    open(null);
    root.dataset.enhanced = "";
});
